// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"_32x6F-NYYuPb0a3B51XZG0","title":"XU9qsM8yOarQMiyWyFvDY","triangleRight":"_3ZauKws_o9bMtQGXxfQ0WK","triangleDown":"_3oXlDjUTO4nzLhJnif2y8B","closed":"_3w6CGpVxCFOgtL0nAC4SoT"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/tennis/css/accordion.css
// module id = 956
// module chunks = 0